import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { closeApp } from '@redux/slices/workflowSlice'
import { claimAcceptedSelector, resetSubmitError } from '@redux/slices/claimSubmitSlice'
import { injectDataAttributes } from '@utils/dataAttributes'
import { useEnvironment } from '@hooks/useEnvironment'
import { usePageFlow } from '@hooks/usePageFlow'
import { Modal } from '../Modal/Modal'
import { FooterAction } from '../Modal/FooterAction'
import { StyledTypography } from '../Typography/StyledTypography'

export const ClaimAcceptedListener: React.FC = () => {
  const dispatch = useDispatch()
  const { translationNamespace } = useEnvironment()
  const accepted = useSelector(claimAcceptedSelector)
  const { t } = useTranslation(translationNamespace, { keyPrefix: 'SubmitSuccess' })
  const { modalOptions } = usePageFlow()

  const onProceedToCheckout = () => {
    dispatch(resetSubmitError())
    dispatch(closeApp())
  }

  const footer =
    <FooterAction
      onClick={onProceedToCheckout}
      renderAs='button'
      label={t('accepted.proceed-cta')}
      dataAttributes={injectDataAttributes('modal.proceedToCheckout')}
    />
  
  return (
    <Modal
      open={accepted}
      onClose={onProceedToCheckout}
      title={t('accepted.title')}
      footer={footer}
    >
      <StyledTypography textAlign={modalOptions?.textAlign} dangerouslySetInnerHTML={{__html: t('accepted.message')}}></StyledTypography>
    </Modal>
  )
}
